import React from 'react';
import LoginForm from '../../containers/LoginForm/LoginForm';

import './Login.scss';

const Login = () => {

  return (
    <div className='login-page'>
      <LoginForm />
    </div>
  );
};

export default Login;
